/**
 * 기획전 API 서비스
 *
 * 새 Hono 백엔드(/api/v1/promotions/*) 호출
 */
import type { ApiClient } from "@/shared/api/client";

export interface PromotionProductItem {
  id: number;
  name: string;
  idBrand: number;
  imagePath: string;
  goodsPrice: number;
  fixedPrice: number;
  brandName: string;
}

export interface PromotionBrandSummary {
  id: number;
  name: string;
  thumbnail: string;
}

export interface ChuseokTheme {
  id: string;
  title: string;
  date: string;
  description: string;
  idCategory: number;
  idSubcategories: number[];
  sourceLabel: string;
  products: PromotionProductItem[];
}

export interface ChuseokResponse {
  period: { start: string; end: string };
  themes: ChuseokTheme[];
}

export type FamilyMonthTheme = ChuseokTheme;
export type FamilyMonthResponse = ChuseokResponse;

export interface AutumnNewArrivalsBrandEntry {
  brand: PromotionBrandSummary;
  products: PromotionProductItem[];
}

export interface AutumnNewArrivalsResponse {
  brands: AutumnNewArrivalsBrandEntry[];
}

/** @deprecated Use AutumnNewArrivalsBrandEntry. */
export type SpringCollectionBrandEntry = AutumnNewArrivalsBrandEntry;
/** @deprecated Use AutumnNewArrivalsResponse. */
export type SpringCollectionResponse = AutumnNewArrivalsResponse;

export interface MdsPickResponse {
  week: { number: number; start: string; end: string };
  products: PromotionProductItem[];
}

export function createPromotionService(client: ApiClient) {
  return {
    getChuseok: () => client.get<ChuseokResponse>("/promotions/chuseok"),
    getFamilyMonth: () => client.get<FamilyMonthResponse>("/promotions/family-month"),
    getAutumnNewArrivals: () =>
      client.get<AutumnNewArrivalsResponse>("/promotions/autumn-new-arrivals"),
    getSpringCollection: () =>
      client.get<SpringCollectionResponse>("/promotions/spring-collection"),
    getMdsPick: () => client.get<MdsPickResponse>("/promotions/mds-pick"),
  };
}
